import Web3 from 'web3';
import WalletConnectProvider from '@walletconnect/web3-provider';
import detectEthereumProvider from '@metamask/detect-provider';
import { CHAINs, RPC } from '@/abi/token';
import i18n from '../plugins/i18n';
import { Component, Vue } from 'vue-property-decorator';
import { providers } from "ethers";

@Component
export class Web3Mixin extends Vue {
    // computed
    get chainId() {
        return this.$store.state.chainId;
    }
    get chainIdNumber() {
        return this.$store.state.chainIdNumber;
    }
    get web3() {
        return this.$store.state.web3;
    }
    get provider() {
        return this.$store.state.provider;
    }
    get walletConnected() {
        return this.$store.state.walletConnected;
    }

    async initProviderWalletConnect() {
        try {
            const provider = new WalletConnectProvider({
                infuraId: process.env.VUE_APP_INFURA_ID,
                rpc: RPC,
                qrcode: true,
                chainId: this.walletConnected.chainId,
                qrcodeModalOptions: {
                    mobileLinks: [
                        "metamask",
                        "trust",
                    ]
                }
            });
            await provider.enable();
            const web3Provider = new providers.Web3Provider(provider);
            const signer = await web3Provider.getSigner();
            const address = await signer.getAddress();
            const status = true
            const chainId = await provider.request({ method: "eth_chainId" });
            this.$store.commit('SET_WALLET_CONNECTED', {
                walletAddress: address,
                connectedWallet: status,
                wallet: 'wallet_connect',
                chainId: chainId
            })
            this.$store.commit('SET_PROVIDER', provider)
            this.registerEventProvider()

        } catch (error) {
            // @ts-ignore
            console.log(error);
            this.$store.commit('SET_PROVIDER', null)
        }
    }

    async initMetamaskProvider() {
        //  Create WalletConnect Provider
        const ethereum = await detectEthereumProvider({
            mustBeMetaMask: true,
            timeout: 10000,
        });
        if (!ethereum) {
            this.$store.commit('SET_PROVIDER', null)
        }
        this.$store.commit('SET_PROVIDER', ethereum)
    }

    async initTrustWalletProvider() {
        const ethereum = await detectEthereumProvider({
            mustBeMetaMask: false,
            timeout: 10000,
        });
        if (!ethereum) {
            this.$store.commit('SET_PROVIDER', null)
        }
        this.$store.commit('SET_PROVIDER', ethereum)
    }

    initWeb3() {
        this.$store.commit('SET_WEB3', new Web3(this.provider))
    }

    registerEventProvider() {
        this.provider.on('accountsChanged', async (accounts) => {
            if (this.walletConnected.connectedWallet
                && this.walletConnected.wallet !== 'wallet_connect'
                && this.provider instanceof WalletConnectProvider) {
                await this.provider.disconnect();
                this.$store.commit('SET_WALLET_CONNECTED', {
                    walletAddress: '',
                    connectedWallet: false,
                    wallet: null,
                    chainId: null
                })
                return window.location.reload()
            }
            await this.checkConnected();
        });
        this.provider.on('chainChanged', async (newChainId) => {
            if (this.walletConnected.connectedWallet &&
                this.walletConnected.wallet !== 'wallet_connect' &&
                this.provider instanceof WalletConnectProvider) {
                await this.provider.disconnect();
                this.$store.commit('SET_WALLET_CONNECTED', {
                    walletAddress: '',
                    connectedWallet: false,
                    wallet: null,
                    chainId: null
                })
                return window.location.reload()
            }
            await this.checkConnected();
        });
        this.provider.on('disconnect', (code, reason) => {
            this.$store.commit('SET_WALLET_CONNECTED', {
                walletAddress: '',
                connectedWallet: false,
                wallet: null,
                chainId: null
            })
        });
    }

    async checkConnected() {
        try {
            const accounts = await this.provider.request({ method: 'eth_accounts' });
            let wallet = 'metamask'
            if (this.provider instanceof WalletConnectProvider) {
                wallet = 'wallet_connect'
            }
            return this.handleAccountChange(accounts, wallet);
        } catch (error) {
            this.$store.commit('SET_WALLET_ADDRESS', '')
            console.log(error);
        }
    }

    async handleAccountChange(accounts, wallet) {
        if (accounts.length === 0) {
            this.$store.commit('SET_WALLET_CONNECTED', {
                walletAddress: '',
                connectedWallet: false,
                wallet: null,
                chainId: null
            })
            return false;
        }
        // eslint-disable-next-line
        if (this.walletConnected.walletAddress == accounts[0]) {
            this.$store.commit('SET_WALLET_CONNECTED', {
                walletAddress: accounts[0],
                connectedWallet: true,
                wallet: wallet,
                chainId: this.walletConnected.chainId
            })
            return;
        }
        this.$store.commit('SET_WALLET_CONNECTED', {
            walletAddress: accounts[0],
            connectedWallet: true,
            wallet: wallet,
            chainId: this.walletConnected.chainId
        })
        return true;
    }

    async switchEthereumChain(chainId) {
        try {
            await this.provider.request(CHAINs[chainId]);
            return true;
        } catch (addError) {
            return false;
        }
    }

    async disconnectWallet () {
        try {
            if (this.walletConnected.wallet  === 'wallet_connect') {
                this.provider.disconnect();
            }
        } catch (e) {

        }
        this.$store.commit('SET_WALLET_CONNECTED', {
            walletAddress: '',
            connectedWallet: false,
            wallet: null,
            chainId: null
        })
    }
}
